export const CHAT_WIDTH = '576px';
